import {useHistoryPageState} from '@aboutyou/history-page-state';
import {useQueryParamsCallback} from '@aboutyou/router';
import {getDisplayedElementAfterTransition} from '@aboutyou/transitions';
import {useCallback, useEffect, useRef} from 'react';
import {WALLET_STATE_MANAGER_PARAM} from './useWalletStateManager';

export type WalletType = 'coins' | 'coupons' | 'notificationCenter';

export const useActiveTab = () => {
  const getQueryParams = useQueryParamsCallback();
  const queryParams = getQueryParams();
  const walletContentRef = useRef<HTMLDivElement>(null);

  const activeTabFromQueryParam = queryParams.get(
    WALLET_STATE_MANAGER_PARAM,
  ) as WalletType;

  const [activeTab, setActiveTab] = useHistoryPageState<WalletType>(
    activeTabFromQueryParam,
    {
      uniqueKey: 'WALLET_ACTIVE_TAB',
    },
  );

  const scrollToTop = useCallback(() => {
    setTimeout(() => {
      const el = getDisplayedElementAfterTransition(
        document.body,
        'wallet-content',
      );

      el?.scrollTo({top: 0});
    }, 100);
  }, []);

  useEffect(() => {
    // eslint-disable-next-line local-rules/set-state-in-use-effect
    if (activeTabFromQueryParam) {
      setActiveTab(activeTabFromQueryParam);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [activeTabFromQueryParam]);

  const onTabClick = (value: WalletType) => {
    scrollToTop();
    setActiveTab(value);
  };

  return {
    activeTab,
    onTabClick,
    walletContentRef,
  };
};
